var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoActive = function SvgInfoActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M5.667 10.833h6.666A3.67 3.67 0 0 1 16 14.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 3.667 3.667 0 0 1 3.667-3.667ZM9 2.5a2.834 2.834 0 1 1 0 5.669A2.834 2.834 0 0 1 9 2.5Z"
  })));
};
export default SvgInfoActive;